import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Index from "./pages/Index";

// Páginas carregadas sob demanda (o PDF só é baixado no gerador)
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Contato = lazy(() => import("./pages/Contato"));
const Corregedoria = lazy(() => import("./pages/Corregedoria"));
const Anuencias = lazy(() => import("./pages/Anuencias"));
const GeradorAnuencia = lazy(() => import("./pages/GeradorAnuencia"));
const Cancelamentos = lazy(() => import("./pages/Cancelamentos"));
const Certidoes = lazy(() => import("./pages/Certidoes"));
const Protestos = lazy(() => import("./pages/Protestos"));
const Missao = lazy(() => import("./pages/Missao"));
const Alerta = lazy(() => import("./pages/Alerta"));
const LinksApps = lazy(() => import("./pages/LinksApps"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const PageFallback = () => (
  <div className="min-h-screen flex items-center justify-center text-muted-foreground">
    Carregando...
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/corregedoria" element={<Corregedoria />} />
            <Route path="/servicos/anuencias" element={<Anuencias />} />
            <Route path="/servicos/anuencias/gerador" element={<GeradorAnuencia />} />
            <Route path="/servicos/cancelamentos" element={<Cancelamentos />} />
            <Route path="/servicos/certidoes" element={<Certidoes />} />
            <Route path="/servicos/protestos" element={<Protestos />} />
            <Route path="/missao" element={<Missao />} />
            <Route path="/alerta" element={<Alerta />} />
            <Route path="/links-e-apps" element={<LinksApps />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <WhatsAppButton />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
